export const getCurrentUsers = users =>
  users.filter(user => user.latest_status === 'active');
